var map = {
	"./base/aos": [
		326,
		326
	],
	"./base/aos.ts": [
		326,
		326
	],
	"./base/novotel": [
		770,
		770
	],
	"./base/novotel.ts": [
		770,
		770
	],
	"./base/qr-main": [
		836,
		836
	],
	"./base/qr-main.ts": [
		836,
		836
	],
	"./helpers/link-prefetch": [
		907,
		907
	],
	"./helpers/link-prefetch.ts": [
		907,
		907
	],
	"./import-functions": [
		744
	],
	"./import-functions.ts": [
		744
	],
	"./init-scripts": [
		2
	],
	"./init-scripts.ts": [
		2
	],
	"./main": [
		477
	],
	"./main.ts": [
		477
	],
	"./modules/lottie": [
		732,
		847,
		732
	],
	"./modules/lottie.ts": [
		732,
		847,
		732
	],
	"./modules/text-slider": [
		512,
		629,
		512
	],
	"./modules/text-slider.ts": [
		512,
		629,
		512
	],
	"./utils/variables": [
		442
	],
	"./utils/variables.ts": [
		442
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 606;
module.exports = webpackAsyncContext;